'use strict';

import './index.less';

import React from 'react';
import PropTypes from 'prop-types';

// Vendor
import ReactTable from 'react-table';

// Components
import Spinner from 'ck-core-client/source/components/Spinner';
import PageHeader from 'ck-core-client/source/components/Layout/PageHeader';

class Table extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: props.data,
			columns: props.columns,
			loading: props.loading
		};
	}

	componentWillReceiveProps(newProps) {
		this.setState({
			data: newProps.data,
			loading: newProps.loading
		});
	}

	filter(search) {
		this.setState({
			loading: true
		});

		const filteredData = this.props.data.filter(row => {
			const rows = Object.keys(row);
			return rows.some(key => {
				return (
					row[key]
						.toString()
						.toUpperCase()
						.indexOf(search.toUpperCase()) > -1
				);
			});
		});

		this.setState({
			loading: false,
			data: filteredData
		});
	}

	render() {
		const { title, search, pageSizeOptions } = this.props;

		const { data, columns, loading } = this.state;

		return (
			<div className="Table">
				{title ? <PageHeader subtitle={title} /> : null}
				<div className="Table__container">
					{search && (
						<div className="Table__filter">
							Filter
							<input
								className="Table__filter-input"
								label="filters"
								name="name"
								type="text"
								onChange={e => {
									this.filter(e.target.value);
								}}
							/>
						</div>
					)}
					<ReactTable
						{...this.props}
						columns={columns}
						data={data}
						loading={loading}
						minRows={0}
						pageSizeOptions={pageSizeOptions}
						showPagination={data.length > 10}
						loadingText={<Spinner />}
						className="-highlight"
					/>
				</div>
			</div>
		);
	}
}

Table.defaultProps = {
	pageSizeOptions: [5, 10, 20]
};

Table.propTypes = {
	data: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
	title: PropTypes.string,
	search: PropTypes.bool,
	loading: PropTypes.bool
};
export default Table;
